export const GET_FEEDBACKS_REQUEST = "GET_FEEDBACK_REQUEST";
export const GET_FEEDBACKS_SUCCESS = "GET_FEEDBACK_SUCCESS";

export const SHOW_FEEDBACK_REQUEST = "SHOW_FEEDBACK_REQUEST";
export const SHOW_FEEDBACK_SUCCESS = "SHOW_FEEDBACK_SUCCESS";

export const DELETE_FEEDBACK_REQUEST = "DELETE_FEEDBACK_REQUEST";
export const DELETE_FEEDBACK_SUCCESS = "DELETE_FEEDBACK_SUCCESS";
